import { CollectionState, FiltersMap } from '@wix/bex-core';

export interface CollectionStateProps<
  T = unknown,
  F extends FiltersMap = FiltersMap,
> {
  state: CollectionState<T, F>;
}
